/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { useState, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import LabelIcon from '@material-ui/icons/Label';
import BulkTagDialog from './BulkTagDialog';
import {
  useGetMany,
  useDataProvider,
  useRefresh,
  useNotify,
  useUnselectAll,
} from 'react-admin';

const BulkTagButton = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data } = useGetMany('assets', props.selectedIds);

  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const dataProvider = useDataProvider();

  const handleClick = async () => {
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const handleAssetsChange = async (assets) => {
    if (assets.length === 0) {
      notify('Assets not changed');
      setIsOpen(false);
      return;
    }

    try {
      await dataProvider.updateMany(props.resource, {
        [props.resource]: assets,
      });
      unselectAll(props.resource);
      notify(`Assets' tags edited`);
    } catch (error) {
      notify(`Assets' tags edit error: ${error.message}`, 'warning');
    } finally {
      refresh();
      setIsOpen(false);
    }
  };

  return (
    <Fragment>
      <BulkTagDialog
        open={isOpen}
        onClose={onClose}
        assets={data}
        onSubmit={handleAssetsChange}
      />
      <Button color="secondary" size="small" onClick={handleClick}>
        <LabelIcon />
        Tag Assets
      </Button>
    </Fragment>
  );
};

export default BulkTagButton;
